module.exports = __webpack_public_path__ + "img/gartek-services-mechanical-custom-solution.6aa7502f.png";